<template>
    <div class="login_container">
        <div class="login_wrap">
            <div class="tit">
                <h1 class="icon_wrap"><img src="img/logo_w.png" alt="반성매매 상담 플랫폼" /></h1>
                <!-- <p>
                    <img src="img/setting_icon.png" alt="관리자 로그인" />
                    관리자 로그인
                </p> -->
            </div>
            <div class="area_form">
                <input type="text" v-model="state.username" v-on:keyup.enter="login" placeholder="아이디" ref="id" />
                <input type="password" v-model="state.password" v-on:keyup.enter="login" placeholder="비밀번호" />
                <button type="button" @click.left="login">로그인</button>
            </div>
        </div>
    </div>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>

<script lang="ts" config>
    import {
        useI18n,
        userStore,
        apiService,
        reactive,
        router,
        onMounted,
        ModalComponent,
        ModalDefault,
        globalStore,
        watch,
        types,
        useRoute,
        getMessageByCode,
        ref,
        zod,
        CommonUtils,
        validate,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { ModalComponent, ModalDefault },
        setup() {
            const user = userStore();
            const global = globalStore();
            const route = useRoute();
            const state = reactive({
                placeholdID: "",
                placeholdPW: "",
                username: "",
                password: "",

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
                modalYes: "확인" as string,

                redirectUrl: "" as any,
            });

            const id = ref<HTMLInputElement | null>(null);

            onMounted(() => {
                user.$reset();
                global.$reset();

                if (route.query.redirect) {
                    state.redirectUrl = route.query.redirect;
                }

                id.value?.focus();
            });
            const t = useI18n();
            const login = async () => {
                // 검증 사용 방식
                const checkValue = CommonUtils.checkValidate(validate.base.login, state);
                if (!checkValue.success) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = checkValue.message;
                    state.isShowModal = true;
                    return;
                }
                const param: types.ReqLogin = {
                    id: state.username,
                    pw: state.password,
                };
                let res: types.ResCommon = await apiService.base.login(param);
                if (res.returnCode === 0) {
                    router.replace("/");
                    // let res2: types.admin.ResUserInfo = await apiService.base.me();
                    // if (res2.returnCode === 0) {
                    //     user.setInfo(res2.data);

                    //     if (state.redirectUrl) router.replace(state.redirectUrl);
                    //     else router.replace("/");
                    // } else if (res2.returnCode === 11) {
                    // } else {
                    //     state.modalTab = -1;
                    //     state.modalTitle = "예외 발생";
                    //     state.modalContent = getMessageByCode(res2.returnCode);
                    //     state.isShowModal = true;
                    // }
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const closeModal = () => {
                state.isShowModal = false;
                state.modalTab = -1;
            };

            const openModal = (tab: number, isResult: boolean) => {
                state.modalTab = tab;
                state.isShowModal = true;
                state.modalIsResult = isResult;
            };

            const callBackModal = async (param: any) => {};

            return {
                state,
                login,
                router,
                closeModal,
                openModal,
                callBackModal,
                id,
            };
        },
    };
</script>
